import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import React from "react";
import styles from "./_loading-indicator.module.scss";

export interface LoadingIndicatorProps {
  label: string;
};

export default function LoadingIndicator(props: LoadingIndicatorProps) {
  return (
    <div className={styles.loadingIndicatorContainer}>
      <CircularProgress />
      <Typography variant="h4" sx={{ fontSize: { xs: "1.25rem", sm: "2.125rem" } }}>
        {props.label}
      </Typography>
    </div>
  );
}
